export default __webpack_public_path__ + "static/media/respaldo-total-internacional.2a0813ad.jpg";